<template>
  <div
    class="Fuell-Table"
    ref="table"
  >
    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item">{{$t('company_funnel_aproval_flow_table_column_name')}}</div>
      <div class="Fuell-Table--item">{{$t('company_funnel_aproval_flow_table_column_aproval_levels')}}</div>
      <div class="Fuell-Table--item">{{$t('company_funnel_aproval_flow_table_column_budgets')}}</div>
      <div class="Fuell-Table--item"></div>
    </div>
    <funnel-aproval-flows-table-row
      v-for="reviewFlow in reviewFlows"
      :key="reviewFlow.id"
      :reviewFlow="reviewFlow"
      @openReviewFunnelDetail="openReviewFunnelDetail"
    />
    <div
      class="d-flex justify-content-center w-100 mt-4"
      v-if="currentPage < lastPage"
    >
      <span
        class="text-primary text-underline clickable"
        @click="nextPage"
      >{{$t('ACTION_LOAD_MORE')}}</span>
    </div>

  </div>
</template>

<script>
import FunnelAprovalFlowsTableRow from './FunnelAprovalFlowsTableRow'

export default {
  name: 'FunnelAprovalFlowsTable',
  components: { FunnelAprovalFlowsTableRow },
  computed: {
    reviewFlows () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/reviewFlows'] || []
    },
    currentPage () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/reviewFlowsCurrentPage']
    },
    lastPage () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/reviewFlowsLastPage']
    }
  },
  methods: {
    openReviewFunnelDetail (event) {
      this.$emit('openReviewFunnelDetail', event)
    },
    nextPage () {
      this.$store.dispatch('CompanyStore/TransactionFieldsStore/nextReviewFlowPage')
    }
  }

}
</script>

<style lang="scss" scoped>
.text-underline {
  text-decoration: underline;
}

@import "@/assets/styles/tables/funnel-aproval-flows-table";
</style>
